"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.YearlyScheduleInfoItemsCreator = void 0;
require("../../core");
const contexts_1 = require("../../core/contexts");
const YearlyScheduleHarmonizationManager_1 = require("./YearlyScheduleHarmonizationManager");
const constants_1 = require("./constants");
const helpers_1 = require("./helpers");
const types_1 = require("./types");
class YearlyScheduleInfoItemsCreator {
    constructor(labels, texts, models, retentionFieldsSettings) {
        this.labels = labels;
        this.texts = texts;
        this.models = models;
        this.retentionFieldsSettings = retentionFieldsSettings;
        this.getYearlyScheduleValue = () => {
            const dailyScheduleModelValue = this.models.dailyScheduleModel.getValue();
            const weeklyScheduleModelValue = this.models.weeklyScheduleModel.getValue();
            const monthlyScheduleModelValue = this.models.monthlyScheduleModel.getValue();
            const modelValue = this.models.yearlyScheduleModel.getValue();
            const initialValue = YearlyScheduleHarmonizationManager_1.YearlyScheduleHarmonizationManager.getMainModelInitialValue(dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue, this.retentionFieldsSettings);
            const dayNumberInMonth = modelValue.fields.dayNumberInMonth;
            const month = modelValue.fields.month;
            const dayOfWeek = modelValue.fields.dayOfWeek;
            const dayOfMonth = modelValue.fields.dayOfMonth;
            const time = modelValue.fields.time;
            const keep = `${modelValue.fields.count}`;
            const type = modelValue.fields.type;
            const isOnDay = dayNumberInMonth === types_1.DAY_NUMBER_IN_MONTH.onDay;
            const isLastDay = parseInt(dayOfMonth) === constants_1.LAST_DAY_OF_MONTH;
            const isOnLastDay = isOnDay && isLastDay;
            let dayOfWeekOrMonth = this.texts[initialValue.fields.dayOfWeek];
            if (isOnDay) {
                dayOfWeekOrMonth = isLastDay ? this.texts.lastDay : dayOfMonth;
            }
            else if (dayOfWeek) {
                dayOfWeekOrMonth = this.texts[dayOfWeek];
            }
            const dayNumberInMonthText = this.texts[isOnLastDay ? types_1.EXTENDED_DAY_NUMBER_IN_MONTH.onLastDay : dayNumberInMonth];
            return {
                dayNumberInMonth: dayNumberInMonth && dayNumberInMonthText,
                month: month ? this.texts[month] : this.texts[initialValue.fields.month],
                dayOfWeekOrMonth,
                time,
                keep,
                type,
            };
        };
        this.getYearlySettingsValue = () => {
            const value = this.getYearlyScheduleValue();
            return contexts_1.parseTextConfig(this.texts.yearlySettingsFilled, value);
        };
        this.getYearlyRetentionValue = () => {
            const value = this.getYearlyScheduleValue();
            const keep = parseInt(value.keep);
            return `${value.keep} ${helpers_1.getUnitSingularPluralLabel(this.texts, keep || 0, value.type)}`;
        };
        this.getScheduleInfoItems = (isRowThirdEnabled, isArchivable, isArchived, thirdRowRepositoryName, archivedThirdRowRepositoryName, archivedThirdRowRepositoryStorageClass) => {
            const scheduleInfoItems = [
                {
                    label: this.texts.yearlySettingsLabel,
                    value: this.getYearlySettingsValue(),
                },
                {
                    label: this.texts.yearlyRetentionCountLabel,
                    value: this.getYearlyRetentionValue(),
                },
            ];
            if (isRowThirdEnabled && isArchivable) {
                const repositoryName = isArchived ? archivedThirdRowRepositoryName : thirdRowRepositoryName;
                const storageClassName = isArchived && archivedThirdRowRepositoryStorageClass
                    ? archivedThirdRowRepositoryStorageClass
                    : this.texts.storageClassS3;
                const storageClass = contexts_1.parseTextConfig(this.texts.storageClassLabel, {
                    storageClass: storageClassName,
                });
                scheduleInfoItems.push({
                    label: this.texts.repositoryLabel,
                    value: `${repositoryName} ${storageClass}`,
                });
            }
            return scheduleInfoItems;
        };
        this.labels = labels;
        this.texts = texts;
        this.models = models;
        this.retentionFieldsSettings = retentionFieldsSettings;
    }
}
exports.YearlyScheduleInfoItemsCreator = YearlyScheduleInfoItemsCreator;
//# sourceMappingURL=YearlyScheduleInfoItemsCreator.js.map